import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/forms';


class PageFormSubmissionEdit extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {form, submission} = this.props;

    return (
      <MainLayout className="page-formsub-edit">
        <Meta title="Edit Answers | Millie" />
        <div className="widther">
          <h1>Edit Answers</h1>
          {!!(form && submission) && <Form form={form} company={form.company} submission={submission} />}
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  form: FormsDuck.Slx.pgSubEditForm(state),
  submission: FormsDuck.Slx.pgSubEditSubmission(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageFormSubmissionEdit);
